<!-- 销售退货申请操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="140px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []"><!-- 记账单号 -->
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                            <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1"></el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"></el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 退货申请日期 -->
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                                                             :isdisabled="formOneValue.isChange == 0" :isShowLong="false"></df-date>
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                               :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]"
                                                               placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(
                                                        formOneValue.formatterContent
                                                    )" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 退货原因 -->
                                                    <el-input clearable v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)"
                                                              v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                                        sendDataInfo[formOneValue.entityField]
                                                        == 1 ? "是" : "否" }}</span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini">
                                        <!-- 操作 -->
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="deleteDetails()">删除明细</el-button>
                                        </div>
                                        <!-- 明细 -->
                                        <el-table :data="sendDataInfo.desuRgapplyDetails" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                                  @selection-change="handleSelectionChange" id="mxTable" :height="mxHeight" border style="width: 100%" size="mini">
                                            <el-table-column width="90" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <template v-for="(formOneValue, formOneKey) in mxForm">
                                                <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :key="formOneKey"
                                                                 v-if="formOneValue.isShow == 1">
                                                    <template slot-scope="scope">
                                                        <!-- 有效期 -->
                                                        <span v-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                        </span>
                                                        <span v-else-if="formOneValue.fieldType == 'date'">
                                                            <span v-if="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                            </span>
                                                        </span>
                                                        <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, formOneValue.nosetField)"
                                                                  v-model="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, formOneValue.nosetField)"
                                                                       slot="append" icon="el-icon-search"></el-button>
                                                        </el-input>
                                                        <!-- 退货数量 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'rgadRetnumber' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                  v-model="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]" type="number"
                                                                  :max="sendDataInfo.desuRgapplyDetails[scope.$index].woadPnumber" @blur="blur(scope.$index, formOneValue.entityField)" @input="detailListener"></el-input>
                                                        <!-- 备注	 -->
                                                        <el-input v-else-if="formOneValue.entityField == 'rgadRemark' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                                  @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                  v-model.trim="sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                        <span v-else>{{
                                                        sendDataInfo.desuRgapplyDetails[scope.$index][formOneValue.entityField]
                                                    }}</span>
                                                    </template>
                                                </el-table-column>
                                            </template>
                                        </el-table>
                                    </el-form>
                                </div>
                                <div v-if="scope.index == 1">
                                    <el-form label-width="140px" id="mainInfo" class="baseForm" :model="sendDataInfo.pisRegoCtri" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []"><!-- 记账单号 -->
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                                :disabled="sendDataInfo.pisRegoCtri[formOneValue.entityField]==null||sendDataInfo.pisRegoCtri[formOneValue.entityField]==''?true:false || sendDataInfo.pisRegoCtri[formOneValue.entityField].length<=9"
                                                                effect="dark" :content="sendDataInfo.pisRegoCtri[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                            <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1"></el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                                :disabled="sendDataInfo.pisRegoCtri[formOneValue.entityField]==null||sendDataInfo.pisRegoCtri[formOneValue.entityField]==''?true:false || sendDataInfo.pisRegoCtri[formOneValue.entityField].length<=9"
                                                                effect="dark" :content="sendDataInfo.pisRegoCtri[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"></el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 退货申请日期 -->
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]"
                                                             :isdisabled="formOneValue.isChange == 0" :isShowLong="false"></df-date>
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                               :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" @change="$forceUpdate()" v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]"
                                                               placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(
                                                        formOneValue.formatterContent
                                                    )" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 退货原因 -->
                                                    <el-input clearable v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)"
                                                              v-model.trim="sendDataInfo.pisRegoCtri[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.pisRegoCtri[formOneValue.riftField])">{{
                                                        sendDataInfo.pisRegoCtri[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.pisRegoCtri[formOneValue.entityField]">
                                                            {{
                                                            $common.getLocalTime(sendDataInfo.pisRegoCtri[formOneValue.entityField])
                                                        }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                                        sendDataInfo.pisRegoCtri[formOneValue.entityField]
                                                        == 1 ? "是" : "否" }}</span>
                                                    <span v-else>{{ sendDataInfo.pisRegoCtri[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>

                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <ExtractionScheme ref="extractionScheme" :isOrderSource='true' :ppId="ppId" :id="exId" :extractParamsData="extractParamsData" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import ExtractionScheme from '../byComponents/ExtractionScheme.vue'
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: 'oneStepsalesInitiaReturnAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionScheme, SearchScheme },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                wobkemId: '',
                "desuRgapplyDetails": [],
                pisRegoCtri: {
                    "controlStatus": "",
                    "haulTool": "",
                    "highTemperature": "",
                    "hippingLocation": "",
                    "lowTemperature": "",
                    "numberPlate": "",
                    "psrgciArrtem": "",
                    "psrgciArrtime": 0,
                    "psrgciRemark": "",
                    "psrgciStrantem": "",
                    "psrgciStrantime": 0,
                    "psrgciTconmode": "",
                    "psrgciTranmode": "",
                    "trafficUnit": ""
                },
                "coId": '',
                "coName": '',
                "rgaiAccperiod": "",
                "rgaiDismode": "",
                "payMethod": "",
                "rgaiReserves1": "",
                "rgaiReserves2": "",
                "rgaiReserves3": "",
                "rgaiReserves4": "",
                "rgaiReserves5": "",
                "rgaiReserves6": "",
                "settleMethod": "",
                salesId: "",
                salesName: "",
                "opmId": '',
                "cmId": '',
                cmName: '',
                "rgamRapdate": 0,
                "rgamRemark": "",
                "rgamReserves1": "",
                "rgamReserves2": "",
                "rgamReserves3": "",
                "rgamReserves4": "",
                "rgamReserves5": "",
                "rgamReserves6": "",
                "depId": '',
                "depName": '',
                "totalCount": 0,
                "totalMoney": 0,
                "totalNumber": 0,
                "woamId": '',
                rgamId: '',
                credit: "",
                dismode: '',
                isWms: "",
                returnReason: ''
            },

            showTabs: '',
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            exTitle: '',//缓存提取
            exWidth: '',
            DialogExtract: false,
            ppId: 'wobkemId',
            exId: '',
            selectedDetailsIndex: 0,	//选择操作数据
            mxHeight: 0,	//明细表格高
            dictionariesDatas: [], //配送方式
            returnResonArray: [],	//退货原因
            mxForm: [],
            tabForm: [],
            footForm: [],
            sField: '', // 赋值字段
            fField: '', //焦点字段
            nosField: '', // 不可赋值字段
            inputel: '', //所有input对象
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: '',
            parentSearchData: {},
            selectedRow: [], // 当前已选择行
            extractParamsData: {}
        }
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.desuRgapplyDetails': {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalCount = newValue.length//
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        blur(index, name) {
            this.sendDataInfo.desuRgapplyDetails[index][name] = this.$common.getDecimalInfo(3, this.sendDataInfo.desuRgapplyDetails[index][name])
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField) {
            this.parentSearchData = {}
            this.DialogVisible = true;
            removeEventListener('keyup', this.keyUp)
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            this.nosField = nosField
            this.parentSearchData[type] = this.sendDataInfo[type]
            if (type == 'regoName') {
                this.$set(this.parentSearchData, 'opmBuyer', "")
                this.$set(this.parentSearchData, 'opmKeeper', 1)
                this.$set(this.parentSearchData, 'opmDelivery', 1)
                this.$set(this.parentSearchData, 'opmAcceptor', "")
            }
            if (type == 'pschaName') {
                this.$set(this.parentSearchData, 'opmBuyer', "")
                this.$set(this.parentSearchData, 'opmAcceptor', 1)
                this.$set(this.parentSearchData, 'opmDelivery', "")
                this.$set(this.parentSearchData, 'opmKeeper', "")
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp)//创建监听键盘事件
                if (this.seType == 'stName') {
                    this.paramValue1(val)
                } else {

                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        // 赋值字段
        paramValue1(val) {
            console.log(val);
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo.desuRgapplyDetails[this.seIndex][item] = val[item]
            })
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableNextFocus(this.fField, this.seIndex)
                }, 16.4)
            })
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.desuRgapplyDetails.length > 0) {
                    this.tableNextFocus('rgadRetnumber', this.selectedDetailsIndex)
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    })
                }
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }

            this.inputel[aindex].focus()
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == '') return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.desuRgapplyDetails.length - 1) return
                if (this.sendDataInfo.desuRgapplyDetails[index + 1] != undefined) {
                    this.$refs['rgadRetnumber'][index + 1].focus() //跳退货数量
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 新增明细
                e.preventDefault();
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.desuRgapplyDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.desuRgapplyDetails.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.desuRgapplyDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.desuRgapplyDetails.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 触发提取方案
        openExComponents(e, index, type) {
            this.exId = e;
            this.seType == type
            this.seIndex = index
            this.DialogExtract = true;
            this.extractParamsData[type] = this.sendDataInfo[type]
            removeEventListener('keyup', this.keyUp)
        },

        // 获取 提取单数据
        async getExData(res) {
            let val = JSON.parse(JSON.stringify(res))
            console.log('提取', val);
            if (val != "" || val != undefined) {
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        // val.arrlistbychen.forEach((v)=>{
                        // 	v.rgadRetnumber = 0
                        // 	v.money = 0
                        // 	v.psmoney = 0
                        // 	v.costMoney = 0
                        // 	v.gross = 0
                        // 	v.costAmount = 0
                        // })
                        this.sendDataInfo.desuRgapplyDetails = JSON.parse(JSON.stringify(val.arrlistbychen))
                        this.sendDataInfo.desuRgapplyDetails.forEach(item => {
                            // this.$set(item,'rgadRetnumber',0)
                            this.$set(item, 'money', 0)
                            this.$set(item, 'psmoney', 0)
                            this.$set(item, 'rgadRecostMoneytnumber', 0)
                            this.$set(item, 'gross', 0)
                            this.$set(item, 'costAmount', 0)

                        })
                    } else {
                        this.sendDataInfo[key] = val[key];
                    }
                }

                this.detailListener()

                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    this.nextFocus(this.seIndex)
                })
                this.sendDataInfo.accountTime = new Date().getTime()
            } else {
                this.$message({
                    message: '未拿到数据',
                    type: 'error'
                })
            }
            this.DialogExtract = false
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach(item => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.depId = item.depId
                    this.sendDataInfo.depName = item.depName
                }
            })
            console.log(data)
        },
        //确认新增
        async sendDataAction(formName) {
            let flag = false
            this.$refs[formName].validate((valid) => {
                if (valid) {

                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;
            if (!this.sendDataInfo.wobkemId || this.sendDataInfo.wobkemId == '') {
                this.$message({
                    message: '请选择销售出库记账单号',
                    type: 'error'
                });
                return false
            }
            if (this.sendDataInfo.desuRgapplyDetails.length < 1) {
                this.$message({
                    message: '请添加退回明细',
                    type: 'error'
                });
                return false
            }
            for (let i = 0; i < this.sendDataInfo.desuRgapplyDetails.length; i++) {
                const element = this.sendDataInfo.desuRgapplyDetails[i]
                if (!element.rgadRetnumber || element.rgadRetnumber <= 0 || (element.rgadRetnumber > element.woadPnumber)) {
                    this.$message({
                        message: '请填写合理的退回数量',
                        type: 'error'
                    });
                    return false
                }
            }
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            var responseData
            if (this.dataActionBox.actionType == 0) {
                // if (this.$route.name == 'storeReturnList') {//路由storeDeliveryList 是否是门店配送单页面
                //         sendData.storeType = 1
                //     }
                responseData = await this.$http.returnGoodsAddOneAccount(sendData)
            }
            // else {
            //     responseData = await this.$http.setSalesReturn(sendData)
            // }
            if (responseData.status == 200) {
                this.init()
                this.$emit('drawerCancel')
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //删除明细
        deleteDetails() {
            if (this.sendDataInfo.desuRgapplyDetails.length < 1) {
                this.$message({
                    message: '请先添加明细',
                    type: 'error'
                });
                return false
            }
            this.sendDataInfo.desuRgapplyDetails.splice(this.selectedDetailsIndex, 1)
            this.$nextTick(() => {
                if (this.sendDataInfo.desuRgapplyDetails.length > 1) {
                    this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                    this.tableNextFocus('rgadRetnumber', this.selectedDetailsIndex)
                } else {
                    this.selectedDetailsIndex = 0
                }
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
            })
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform
            arr.forEach(item => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this.sendDataInfo[item.entityField] = item.defaultValue
                }
            })
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
        },
        //初始
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'pisRegoCtri') {
                    // this.sendDataInfo[key]
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = ''
                    }
                } else {
                    this.sendDataInfo[key] = ''
                }
            }
            this.sendDataInfo.desuRgapplyDetails = []
            this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
        },
        //取消
        initActionBox(formName) {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$common.delOrderInfo(this.sendDataInfo.wobkemId)
                this.$emit('drawerCancel')
                this.init()
                this.$refs[formName].resetFields();
            }).catch(() => { });
        },

        // 提取数据
        async extractData(data) {
            if (data.length >= 1) {
                var sendData = []
                data.forEach(items => {
                    sendData.push(items.wobkedId)
                })
                let responseData = await this.$http.extractSalesOrder({ ids: sendData })
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result
                    this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }

        },

        async isShowData(name, value) {
            console.log(name)
            switch (name) {
                case 'cmId':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.cmId = dataInfo.cmId
                        this.sendDataInfo.cmName = dataInfo.cmName

                    }
                    console.log(dataInfo)
                    break;

                case 'cargoOwner':
                    var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
                    console.log(dataInfo)
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.sendDataInfo.desuRgapplySupInfo.coId = dataInfo.coId
                        this.sendDataInfo.desuRgapplySupInfo.coName = dataInfo.coName
                    }

                    break;
            }
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init()
            this.getSpecialUser()
            this.getPartDictionariesData()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
                this.initDefaultValue()
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rgamId)
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },

        //明细监听函数
        detailListener() {
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
            this.sendDataInfo.desuRgapplyDetails.forEach((item, keys) => {
                if (!item.rgadRetnumber || item.rgadRetnumber < 0) {
                    this.sendDataInfo.desuRgapplyDetails[keys].rgadRetnumber = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].money = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].psmoney = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].costMoney = 0	//成本金额
                    this.sendDataInfo.desuRgapplyDetails[keys].gross = 0	//毛利
                    this.sendDataInfo.desuRgapplyDetails[keys].costAmount = 0	//成本金额
                    return false
                }
                if (NP.minus(Number(item.woadPnumber), Number(item.returnNum)) < Number(item.rgadRetnumber)) {
                    this.$message({
                        message: '退货数量+已退数量不得大于原单数量',
                        type: 'error'
                    })
                    this.sendDataInfo.desuRgapplyDetails[keys].rgadRetnumber = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].money = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].psmoney = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].costMoney = 0	//成本金额
                    this.sendDataInfo.desuRgapplyDetails[keys].gross = 0	//毛利
                    return false
                }
                if (item.rgadRetnumber > item.woadPnumber) {
                    this.$message({
                        message: '退货数量不得大于原单数量',
                        type: 'error'
                    })
                    this.sendDataInfo.desuRgapplyDetails[keys].rgadRetnumber = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].money = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].psmoney = 0
                    this.sendDataInfo.desuRgapplyDetails[keys].costMoney = 0	//成本金额
                    this.sendDataInfo.desuRgapplyDetails[keys].gross = 0	//毛利
                    return false
                }
                // 计算成本金额 成本价格*数量
                this.sendDataInfo.desuRgapplyDetails[keys].costAmount =
                    this.$common.getDecimalInfo(3, NP.times(item.costPrice, item.rgadRetnumber));

                var money = this.$common.getDecimalInfo(3, NP.times(item.price, item.rgadRetnumber))
                var psMoney = this.$common.getDecimalInfo(3, NP.times(item.psprice, Number(item.rgadRetnumber)))
                console.log(this.$common.getDecimalInfo(3, NP.times(item.psprice, Number(item.rgadRetnumber))));
                console.log(psMoney);
                console.log(NP.times(item.psprice, item.rgadRetnumber));
                console.log(item.psprice, item.rgadRetnumber);
                this.sendDataInfo.desuRgapplyDetails[keys].money = money
                this.sendDataInfo.desuRgapplyDetails[keys].psmoney = psMoney

                this.sendDataInfo.desuRgapplyDetails[keys].costMoney = this.$common.getDecimalInfo(3, NP.times(item.woadWcost, item.rgadRetnumber))	//成本金额
                this.sendDataInfo.desuRgapplyDetails[keys].gross = this.$common.getDecimalInfo(3, NP.minus(NP.times(item.psprice, item.rgadRetnumber), NP.times(item.woadWcost, item.rgadRetnumber)))	//毛利

                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, psMoney))
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, item.rgadRetnumber))
            })
            this.sendDataInfo.desuRgapplyDetails.splice(1, 0)
        },

        // 获取供货员
        async getSpecialUser() {

            let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 })
            if (responseData.status == 200) {
                this.userOneList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({ ids: [20, 21] })
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //获取配送方式
        async distributionModes(id, own) {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [id],
            });
            if (responseData.status == 200) {
                this[own] = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //json字符串转换成数组
        toArray(str) {
            str && str.replace(/\\/g, '')
            try {
                var arr = JSON.parse(str);
                if (arr && Array.isArray(arr)) {
                    // console.log(arr)
                    return arr;
                } else {
                    return [];
                }
            } catch (e) {
                return [];
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = [{ entityField: "desuRgapplyDetails" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "rgamRapdate", this.$moment().valueOf())
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.distributionModes(37, 'dictionariesDatas')	//配送
        this.distributionModes(40, 'returnResonArray')	//退货原因
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-drawer {
    outline: none;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>